<template>
  <PageHeader
    title="Telephony"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  />

  <div class="p-4">
    <div class="bg-white rounded-lg border border-gray-200">
      <TelephonyCallLogs_Admin />
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue'
import TelephonyCallLogs_Admin from './TelephonyCallLogs_Admin.vue'

export default {
  name: 'Telephony_Admin',

  components: {
    PageHeader,
    TelephonyCallLogs_Admin,
  },
}
</script>
